import { Injectable } from '@angular/core';
import { Base } from '../models/base-model'

@Injectable()
export class Common {
    static ensurePopoverOnScreen() {
        const distanceFromEdge = 12
        const ui = document.querySelector('app-root  ion-popover .popover-viewport') as HTMLElement

        const maxTop = window.innerHeight - ui.clientHeight - distanceFromEdge
        if (parseInt(ui.style.top, 10) > maxTop) {
            ui.style.top = maxTop + 'px'
        }
        if (parseInt(ui.style.top, 10) < distanceFromEdge) {
            ui.style.top = distanceFromEdge + 'px'
        }
        const maxLeft = window.innerWidth - ui.clientWidth - distanceFromEdge
        if (parseInt(ui.style.left, 10) > maxLeft) {
            ui.style.left = maxLeft + 'px'
        }
        if (parseInt(ui.style.left, 10) < distanceFromEdge) {
            ui.style.left = distanceFromEdge + 'px'
        }
        ui.style.opacity = '100'
    }

    // Technique for accessing menu from: https://github.com/ionic-team/ionic/blob/master/core/src/components/menu/test/preview/index.html
    // And since there can be multiple pages with an add-song-slide (see #392), we have to use
    // internal Ionic state to find it on a not-hidden page
    // https://stackoverflow.com/questions/36544941/can-i-put-logical-operators-in-document-queryselectorall-if-so-how
    static menu(className: string): any {
        // I'd expect to be able to say :not(.ion-page-hidden) but doesn't work.
        // console.log(document.querySelectorAll(':scope :not(.ion-page-hidden) ion-menu.' + className))

        const pages = document.querySelectorAll('.ion-page:not(.ion-page-hidden)')
        return pages.item(pages.length - 1).querySelector('ion-menu.' + className)
    }

    /**
     * Checks if item is null or undefined. Can also check for empty string.
     * @param item
     * @param checkEmptyString Default: true will check string type item is empty
     */
    static isNullOrUndefined(item: any, checkEmptyString: boolean = true) {
        if (typeof 'item' === 'string' && checkEmptyString) {
            return item === undefined || item === null || item === ''
        }
        return item === undefined || item === null
    }

    private static getOutsiteUrl(url: string) {
        const http = 'http://'
        const https = 'https://'
        if (!url.startsWith(http) && !url.startsWith(https)) {
            url = `${http}${url}`
        }
        return url
    }

    static openOutsideUrl(url: string) {
        if (this.isNullOrUndefined(url)) {
            return
        }
        window.open(this.getOutsiteUrl(url), '_blank')
    }

    static matchOrder(collection: Base[], uuids: string[]): Base[] {
        uuids.forEach((uuid: string) => {
            let i = this.findIndexByUuid(collection, uuid)
            i = i < 0 ? 0 : i
            collection.push(collection.splice(i, 1)[0]);
        })
        return collection
    }

    static findIndexByUuid(array: Base[], uuid: string): number {
        for (let i = 0; i < array.length; i++) {
            if (array[i].uuid === uuid) {
                return i
            }
        }
        return -1
    }

    static canDrag(handle): boolean {
        if (handle.tagName === 'INPUT' || handle.tagName === 'BUTTON') {
            return false
        }

        const src = handle.attributes.getNamedItem('src')
        return handle.classList.contains('drag-icon') || (src !== null && src.value === 'assets/imgs/hvmove.png')
        || handle.classList.contains('draggable') || handle.parentElement.classList.contains('draggable')
    }
}

export namespace Common {
    export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
}
